import contractManagement from './contractManagement';
// import spendAnalytics from './spendAnalytics'; // requires the SpendAnalytics page/route (not present in this repo yet)

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [contractManagement]
};

export default menuItems;
